module.exports = "<nav class=\"sidenav dps-manage-tree\"\n        mwlResizable\n        [enableGhostResize]=\"true\"\n        [ngStyle]=\"sideNavStyle\"\n        [resizeEdges]=\"{bottom: false, right: true, top: false, left: false}\"\n        (resizeEnd)=\"onResizeEnd($event)\">\n    <tree-vc #treebar [state]=\"true\"></tree-vc>\n</nav>\n<main class=\"content-area\">\n    <dps-manage-content></dps-manage-content>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dataprotection/dataprotection-vc/manage/dps-manage-vc.html
// module id = 10aE
// module chunks = 0